module.exports = __webpack_public_path__ + "static/img/slide-7.4a86876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-7.jpg
// module id = I6GO
// module chunks = 1